// Decode a JWT payload without verifying the signature. Verification is
// the server's job — the client only reads the payload to drive UI
// (e.g. show the acting-as banner when acting_as_practice_id is set).
//
// Returns null on any parse failure rather than throwing, so callers can
// treat a malformed token the same as "no token."

export interface PmaJwtPayload {
    sub?: string;
    email?: string;
    practice_id?: string | null;
    entitlements?: string[];
    gs_staff?: boolean;
    is_parent?: boolean;
    acting_as_practice_id?: string | null;
    exp?: number;
    [k: string]: unknown;
}

function base64UrlDecode(s: string): string {
    const padded = s.replace(/-/g, '+').replace(/_/g, '/').padEnd(
        s.length + ((4 - (s.length % 4)) % 4),
        '=',
    );
    return atob(padded);
}

export function decodeJwt(token: string | null | undefined): PmaJwtPayload | null {
    if (!token) return null;
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    try {
        const json = base64UrlDecode(parts[1]);
        return JSON.parse(json) as PmaJwtPayload;
    } catch {
        return null;
    }
}
